import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { entityLikeSchemaStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { idLikeSchema } from '@zaoblako/shared/modules/serde/schemas/id-like.schema';
import type { CarCategoryFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-find.dto';

/** Client's transit task limits by car category create and update requests' body - DTO siganture */
export interface TransitTaskCarCategoryLimitFormInterface {
  /** Related car category */
  category: CarCategoryFindInterface;
  /** Limit value */
  limit: number;
}

/** Client's transit task limits by car category create and update requests' body - DTO schema */
export const TransitTaskCarCategoryLimitFormDto = SerdeDtoClass.create<TransitTaskCarCategoryLimitFormInterface>(
  ClientDtoKeysEnum.TRANSIT_TASK_CAR_CATEGORY_LIMIT_FORM_DTO,
  {
    category: {
      label: 'Категория ТС',
      serializer: entityLikeSchemaStrict,
    },
    limit: {
      label: 'Лимит гостевых ТС',
      serializer: idLikeSchema,
    },
  },
);
